import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  formatDemoDateInViewerTZ,
  formatDemoTimeInViewerTZ,
  getDemoListScheduleDisplay,
} from '../../utils/dateTimeUtils';

function IstLine({ istRow, field, variant = 'body2' }) {
  if (!istRow) return null;
  return (
    <Typography variant={variant} sx={{ mb: 0.35, lineHeight: 1.35 }}>
      <Box component="span" sx={{ fontWeight: 700 }}>IST: </Box>
      {istRow[field]}
    </Typography>
  );
}

function CountryLines({ demo, viewerTimezone, field, fallback }) {
  const { countryRows, istRow } = getDemoListScheduleDisplay(demo, viewerTimezone);
  if (!countryRows.length) {
    return (
      <Box>
        <Typography variant="body2">{fallback || '—'}</Typography>
        <IstLine istRow={istRow} field={field} />
      </Box>
    );
  }
  return (
    <Box>
      {countryRows.map((row) => (
        <Typography key={row.country} variant="body2" sx={{ mb: 0.35, lineHeight: 1.35 }}>
          <Box component="span" sx={{ fontWeight: 700 }}>{row.country}: </Box>
          {row[field]}
        </Typography>
      ))}
      <IstLine istRow={istRow} field={field} />
    </Box>
  );
}

export function DemoCountryDateLines({ demo, viewerTimezone }) {
  return (
    <CountryLines
      demo={demo}
      viewerTimezone={viewerTimezone}
      field="dateLine"
      fallback={formatDemoDateInViewerTZ(demo, viewerTimezone)}
    />
  );
}

export function DemoCountryTimeLines({ demo, viewerTimezone }) {
  return (
    <CountryLines
      demo={demo}
      viewerTimezone={viewerTimezone}
      field="timeLine"
      fallback={formatDemoTimeInViewerTZ(demo, viewerTimezone)}
    />
  );
}

export function DemoCountryFullLines({ demo, viewerTimezone, variant = 'body2' }) {
  const { countryRows, istRow } = getDemoListScheduleDisplay(demo, viewerTimezone);
  if (!countryRows.length) {
    return (
      <Box>
        <Typography variant={variant}>
          {formatDemoDateInViewerTZ(demo, viewerTimezone)}
          {demo ? ` · ${formatDemoTimeInViewerTZ(demo, viewerTimezone)}` : ''}
        </Typography>
        <IstLine istRow={istRow} field="line" variant={variant} />
      </Box>
    );
  }
  return (
    <Box>
      {countryRows.map((row) => (
        <Typography key={row.country} variant={variant} sx={{ mb: 0.35, lineHeight: 1.35 }}>
          <Box component="span" sx={{ fontWeight: 700 }}>{row.country}: </Box>
          {row.line}
        </Typography>
      ))}
      <IstLine istRow={istRow} field="line" variant={variant} />
    </Box>
  );
}
